// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-buttons-Button----button-module---button---21K-3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/Button/button.module.scss
// module id = 109
// module chunks = 87192162464282 266247407440589